import "./FlowContainer.css"
import Banner from "../Banner/Banner";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {useCms} from "../../../context/CmsContext";
import ProductContainer from "../ProductContainer/ProductContainer";
import CmsHelper, {PickProgramPageHelper} from "../../Utilities/CmsHelpers";
import GenericError from "../../Utilities/GenericError";
import PopUp from "../../Utilities/PopUp";
import CurrentProductContainer from "../ProductContainer/CurrentProductContainer";
import Loader from "../../Loader/Loader";
import {useAuth} from "../../../context/AuthContext";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import FreeProductContainer from "../ProductContainer/FreeProductContainer";

export default function FlowContainer({children, UpperComponent, packages, update, couponExists, contestState, cmsData, onNext, loading, currentProgram, cancellationFlow, AddonContainer}) {
    const Free = "Lite";
    const {t} = useTranslation();
    const { setCheckLoggedIn } = useAuth();
    const navigate = useNavigate();
    let location = useLocation();
    const unsubscribeFlow = location.state ?? {};

    const [products, setProducts] = useState([]);

    const {renderingType, productBannersData, pickProgramData, loadProductBannersData  } = useCms()

    useEffect(()=>{
        if(!UpperComponent){
            loadProductBannersData();
        }
    }, [UpperComponent, loadProductBannersData])

    useEffect(()=>{
        if(renderingType.error || productBannersData.error || pickProgramData.error){
            setError(true)
        }
    }, [renderingType, productBannersData, pickProgramData])

    const [isMultiMonthly, setIsMultiMonthly] = useState(true);


    const cmsPrograms = useMemo(
        () => PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT),
        [pickProgramData]
    );

    const programInfo = PickProgramPageHelper.getProgramInfo(cmsPrograms);

    const orderMap = programInfo?.programData?.reduce((map, item, index) => { //creates an order map to be used to sort compatibility matrix array
        map[item?.displayName?.value] = index;
        return map;
    }, {});

    const [freeProduct, setFreeProduct] = useState(null);

    useEffect(()=>{
        if((!!cmsPrograms && !!cmsPrograms?.programs) && !!packages.length){
            let packagesWithPromos = packages.flatMap(pkg => {
                const promotions = pkg.promotions || [];
                const baseName = pkg.displayName;
                if (promotions.length === 0) {
                    return [{ ...pkg }];
                }
                return promotions.map(promotion => ({
                    ...pkg,
                    displayName: `${baseName}::${promotion}`,
                }));
            });

            setProducts(packagesWithPromos
                .filter(program => program.displayName !== Free)
                .filter(program => cmsPrograms.programs.some(cmsProgram => program?.displayName === cmsProgram?.displayName?.value && cmsProgram.isMultiMonthly === isMultiMonthly))
                .sort((a, b) => {
                    return orderMap[a?.displayName] - orderMap[b?.displayName];
                })
            )
            setFreeProduct(packagesWithPromos.find(program => program.displayName === Free))
        }
    }, [packages, cmsPrograms, isMultiMonthly]) //eslint-disable-line react-hooks/exhaustive-deps

    const [selectedProduct, setSelectedProduct] = useState(!!sessionStorage.getItem("selectedProgramId") ? JSON.parse(sessionStorage.getItem("selectedProgramId")) : undefined);

    const [error, setError] = useState(false);

    const handleTemp = useRef();


    const [tempState, setTempState] = useState();

    const handleResize = () => {
        if(handleTemp.current && !!handleTemp.current.offsetWidth){
            new Promise(resolve =>{setTimeout(()=> {
                setTempState(handleTemp.current.offsetWidth)
            }, 10)})//gives it some time to load the dom
        }else{
            new Promise(resolve =>{setTimeout(()=>handleResize(), 100)})//gives it some time to load the dom
        }
    };

    useEffect(()=>{
        handleResize()
    },[isMultiMonthly]) //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); //eslint-disable-line react-hooks/exhaustive-deps

    const [switchExists, setSwitchExists] = useState(true);

    useEffect(()=>{
        if(packages && !!packages.length && cmsPrograms && cmsPrograms.programs){
            const withoutFree = packages.filter(program => program?.displayName !== Free);
            if(!!withoutFree.length){
                if(withoutFree
                    .every(program => cmsPrograms.programs.some(cmsProgram => program?.displayName === cmsProgram?.displayName?.value && cmsProgram.isMultiMonthly))){
                    setIsMultiMonthly(true);
                    setSwitchExists(false);
                }else if(withoutFree
                    .every(program => cmsPrograms.programs.some(cmsProgram => program?.displayName === cmsProgram?.displayName?.value && !cmsProgram.isMultiMonthly))){
                    setIsMultiMonthly(false)
                    setSwitchExists(false)
                }
            }else{
                setSwitchExists(false);
            }
        }
    }, [packages, cmsPrograms])

    return (([...products, freeProduct].length > 0 && !!productBannersData) &&
        <>
            {!pickProgramData.error && !productBannersData.error ?
                loading ? <Loader /> :
                    <div className={"pickprogram-wrapper"}>
                        <div className={"pickprogram-upper"}>
                            {!!UpperComponent ?
                                <UpperComponent />:
                                <>
                                    <Banner bannerData={productBannersData}
                                            displayName={packages[0]?.displayName}
                                            deviceType={renderingType} update={update}/>
                                    <div className={"pickprogram-header-wrapper"}>
                                        <div className={"pickprogram-header"}>
                                            <span className={"pickprogram-header-title"}>
                                                {(!!couponExists) ?
                                                    t("pickProgramCouponExistsHeader")
                                                    :
                                                    contestState ?
                                                        update ?
                                                            t("pickProgramContestUpgradeFlowHeader")
                                                            :
                                                            t("pickProgramContestRegistrationFlowHeader")
                                                        :
                                                        cmsData?.title
                                                }
                                            </span>
                                            {(!(!!couponExists) && !!cmsData?.details) && (
                                                <span className={"pickprogram-header-subtitle"}>{cmsData?.details}</span>
                                            )}
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        {(switchExists && !(!!couponExists)) &&
                            <div className={"pickprogram-header-switch"}>
                                <div className={`pickprogram-header-switch-selected ${isMultiMonthly ? "multy" : "monthly"}`} />
                                <button onClick={setIsMultiMonthly.bind(null, true)}>{t("pickProgramSwitchMulti")}</button>
                                <button onClick={setIsMultiMonthly.bind(null, false)}>{t("pickProgramSwitchMonthly")}</button>
                            </div>
                        }
                        <div ref={handleTemp} className={`pickprogram-content ${products.length % 2 === 0 ? "even" : "odd"} ${products.length < 2 ? "single" : ""}`}>
                            {products
                                .map((product, index) => {
                                return (
                                    <ProductContainer key={index}
                                                      product={product}
                                                      isMultiMonthly={isMultiMonthly}
                                                      isSelected={selectedProduct?.productId === product.productId && selectedProduct?.pricePoint === product.pricePoint}
                                                      setSelected={setSelectedProduct.bind(null, product)}
                                                      cancellationFlow={cancellationFlow}
                                                      onNext={onNext.bind(null, product, setError)}
                                    />
                                )
                            })}
                        </div>
                        {(!!freeProduct) &&
                            <div className={`pick-program-current-program ${products.length % 2 === 0 ? "even" : "odd"}`} style={{width: !!tempState ? tempState+"px" : "100%"}}>
                                <FreeProductContainer product={freeProduct} onNext={onNext.bind(null, freeProduct, setError)}/>
                            </div>
                        }
                        {((!!currentProgram && currentProgram?.displayName !== Free && PickProgramPageHelper.programExists(cmsPrograms, currentProgram?.displayName)) && !(!!couponExists) && !cancellationFlow) &&
                            <div className={`pick-program-current-program ${products.length % 2 === 0 ? "even" : "odd"}`} style={{width: tempState+"px"}}>
                                <CurrentProductContainer product={currentProgram} />
                            </div>
                        }

                        {cancellationFlow &&
                            <div className={"cancellation-ctas"}>
                                <button className={"cancellation-primary"} onClick={onNext.bind(null, products[0], setError)}>{t("pickProductCancellationCTAPrimary")}</button>
                                <button className={"cancellation-secondary"} onClick={() => {
                                    setCheckLoggedIn(false);
                                    navigate("/Unsubscribe", {state: unsubscribeFlow});
                                }}>{t("pickProductCancellationCTASecondary")}</button>
                            </div>
                        }

                        {!!AddonContainer &&
                            <AddonContainer className={`${products.length % 2 === 0 ? "even" : "odd"}`} style={{width: tempState+"px", alignSelf:"center"}} />
                        }

                        <div className={`pick-program-current-program disclaimers ${products.length % 2 === 0 ? "even" : "odd"}`} style={{width: tempState+"px", alignSelf:"center"}}>
                            {products.filter(product => product?.displayName !== Free).slice(0,1)
                                .map((product, index) => {
                                    const cmsProgramDisclaimers = PickProgramPageHelper.getProgramDisclaimers(programInfo, product?.displayName);
                                    return (cmsProgramDisclaimers?.value.map((disclaimer, index) => <span key={index} style={{fontSize: "14px", fontWeight:"300"}}>{disclaimer.value}</span>))
                                })
                            }
                        </div>
                    </div> :
                <></>
            }

            <PopUp
                openPopUp={error}
                setOpenPopUp={setError}
                maxWidth="md"
                showCloseButton={false}
                outlined={false}
                error={true}
                closeWhenClickedOutside={false}
            >
                <GenericError
                    setClose={setError}
                    mainText={t("pickProgramGenericError")}
                    secondaryText={t("pickProgramGenericErrorSecondary")}
                />
            </PopUp>
        </>
    );
}
